import React, { FC } from 'react';

const PageLoader: FC = () => <div>Loading</div>;

export default PageLoader;
